import type { ReactNode } from "react";
import { Trans } from "../../util/useT.ts";

export const SeasonLabel = ({
	className,
	season,
}: {
	className?: string;
	season: number;
}) => {
	return <span className={className}>{season}</span>;
};

export const highlightLeaderText = (
	<Trans
		i18nKey="common.highlightLeader"
		ns="ui"
		defaults="<bold>Bold</bold> indicates league leader"
		components={{ bold: <span className="highlight-leader" /> }}
	/>
);

export const MaybeBold = ({
	bold,
	children,
}: {
	bold: boolean | undefined;
	children: ReactNode;
}) => {
	if (bold) {
		return <span className="highlight-leader">{children}</span>;
	}

	return children;
};
